import React, { FunctionComponent } from 'react'
import { Card } from '../../../components/card'

export interface Props {
  gridClass?: string
}

export const DefaultCard: FunctionComponent<Props> = () => (
  <Card title="Bank" gridClass="user-bank-accounts">
    <div className="user-bank-accounts__default-card">
      <p className="user-bank-accounts__content--default">
        No bank account linked
      </p>
    </div>
  </Card>
)

DefaultCard.displayName = 'DefaultCard'
